module.exports = __webpack_public_path__ + "static/media/adv-banner-img2.9bb0b417.png";